import React, { useState } from 'react';
import PageThumbnail from './PageThumbnail';

function SelectedPagesPreview({ sessionId, selectedPages, onReorder, onRemove }) {
  const [draggedIndex, setDraggedIndex] = useState(null);

  const handleDragStart = (e, index) => {
    setDraggedIndex(index);
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    if (draggedIndex === null || draggedIndex === index) return;

    const newOrder = [...selectedPages];
    const draggedItem = newOrder[draggedIndex];
    
    // Remove from old position
    newOrder.splice(draggedIndex, 1);
    // Insert at new position
    newOrder.splice(index, 0, draggedItem);

    onReorder(newOrder);
    setDraggedIndex(index);
  };

  const handleDragEnd = () => {
    setDraggedIndex(null);
  };

  if (selectedPages.length === 0) {
    return null;
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h2 style={styles.title}>Selected Pages ({selectedPages.length})</h2>
        <p style={styles.subtitle}>Drag to reorder • Click × to remove</p>
      </div>
      <div style={styles.pagesContainer}>
        {selectedPages.map((page, index) => (
          <div
            key={`${page.fileId}-${page.pageNumber}`}
            draggable
            onDragStart={(e) => handleDragStart(e, index)}
            onDragOver={(e) => handleDragOver(e, index)}
            onDragEnd={handleDragEnd}
            style={{
              ...styles.pageWrapper,
              opacity: draggedIndex === index ? 0.5 : 1,
            }}
          >
            <div style={styles.pageNumber}>{index + 1}</div>
            <PageThumbnail
              sessionId={sessionId}
              fileId={page.fileId}
              pageNumber={page.pageNumber}
              isSelected={true}
              onToggle={() => {}}
            />
            <button
              onClick={() => onRemove(page.fileId, page.pageNumber)}
              style={styles.removeButton}
              title="Remove from selection"
            >
              ×
            </button>
            <div style={styles.pageInfo}>
              <span style={styles.fileName}>{page.fileName}</span>
              <span style={styles.pageLabel}>Page {page.pageNumber}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

const styles = {
  container: {
    backgroundColor: '#f8f9fa',
    border: '2px solid #007bff',
    borderRadius: '8px',
    padding: '20px',
    marginBottom: '30px',
  },
  header: {
    marginBottom: '15px',
  },
  title: {
    margin: 0,
    fontSize: '20px',
    color: '#007bff',
    fontWeight: '600',
  },
  subtitle: {
    margin: '5px 0 0 0',
    fontSize: '14px',
    color: '#666',
  },
  pagesContainer: {
    display: 'flex',
    gap: '15px',
    overflowX: 'auto',
    padding: '10px 0',
  },
  pageWrapper: {
    position: 'relative',
    cursor: 'move',
    transition: 'opacity 0.2s',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '5px',
    minWidth: '170px',
  },
  pageNumber: {
    position: 'absolute',
    top: '-10px',
    left: '-10px',
    backgroundColor: '#007bff',
    color: 'white',
    borderRadius: '50%',
    width: '30px',
    height: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    fontSize: '14px',
    zIndex: 10,
    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
  },
  removeButton: {
    position: 'absolute',
    top: '-10px',
    right: '-10px',
    backgroundColor: '#dc3545',
    color: 'white',
    border: 'none',
    borderRadius: '50%',
    width: '30px',
    height: '30px',
    fontSize: '24px',
    fontWeight: 'bold',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: '1',
    zIndex: 10,
    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
  },
  pageInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    fontSize: '12px',
    textAlign: 'center',
    maxWidth: '170px',
  },
  fileName: {
    fontWeight: '500',
    color: '#333',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '100%',
  },
  pageLabel: {
    color: '#666',
    fontSize: '11px',
  },
};

export default SelectedPagesPreview;
